import { baseUrl } from "./navigation";

export type FooterLink = {
  label: string;
  href: string;
  external?: boolean;
  rel?: string;
};

export type FooterSection = {
  title: string;
  type?: "list" | "grid";
  links: FooterLink[];
};

export const footerSections: FooterSection[] = [
  {
    title: "Product",
    type: "list",
    links: [
      { label: "Software Features", href: `/digital-signage-software` },
      { label: "Digital Signage Hardware", href: `/hardware` },
      { label: "Digital Menu Board Software", href: `/solutions/digital-menu-board` },
      { label: "Digital Signage Player", href: `/digital-signage-player` },
      { label: "Interactive Kiosk", href: `/interactive-touch-kiosk-digital-signage-software` },
      { label: "OTT Digital Signage Software", href: `/features/ott-digital-signage` },
      { label: "Queue Management Software", href: `/solutions/digital-signage-queue-management-application` },
      { label: "Visitor Management software", href: `/solutions/digital-signage-kiosk-visitor-management-application` },
      { label: "On-premise Digital Signage", href: `/solutions/on-premise-digital-signage` },
    ],
  },
  {
    title: "Solutions",
    type: "list",
    links: [
      { label: "Corporate Communication", href: `/industries/corporate-digital-signage-software` },
      { label: "Retail Digital Signage", href: `/industries/retail-digital-signage-software` },
      { label: "Digital Signage Hospitality", href: `/industries/hospitality-digital-signage-software` },
      { label: "Multi Channel Employee Communication", href: `/solutions/multi-channel-employee-communication-platform` },
      { label: "Restaurant Digital Signage", href: `/industries/restaurant-digital-signage-software` },
      { label: "Banking & Finance Signage", href: `/industries/finance-digital-signage-software` },
      { label: "Transportation Digital Signage", href: `/industries/transportation-digital-signage-software` },
      { label: "Digital Product Catalogue", href: `/solutions/digital-product-catalogue` },
      { label: "Electronic Bulletin Board", href: `/solutions/electronic-bulletin-board` },
      { label: "Employee Communication App", href: `/solutions/employee-communication-app` },
      { label: "Wayfinding Signage", href: `/solutions/wayfinding-signage` },
    ],
  },
  {
    title: "Enterprise",
    type: "list",
    links: [
      { label: "Integrations & Automation", href: `/digital-signage-integrations` },
      { label: "On-premise Digital Signage", href: `/solutions/on-premise-digital-signage` },
      { label: "Our Services", href: `/digital-signage-services` },
    ],
  },
  {
    title: "Resources",
    type: "list",
    links: [
      { label: "Case Studies", href: `/case-studies` },
      { label: "What is digital signage?", href: `/digital-signage` },
      { label: "Digital Signage Blog", href: `${baseUrl}/blog/` },
      { label: "Apps", href: `/digital-signage-apps` },
      { label: "Pricing", href: `/pricing` },
      { label: "FAQ", href: `/faq` },
    ],
  },
  {
    title: "Company",
    type: "grid",
    links: [
      { label: "About Us", href: `/company/about` },
      { label: "Contact Us", href: `/company/contact` },
      { label: "Support", href: `https://docs.pickcel.com/`, external: true, rel: "noopener" },
      { label: "Press Release", href: `/company/press-release` },
      { label: "Careers", href: `https://angel.co/company/pickcel/jobs`, external: true, rel: "noopener nofollow" },
    ],
  },
  {
    title: "Partner program",
    type: "list",
    links: [
      { label: "White Label Digital Signage", href: `/partners/white-label-digital-signage-software` },
      { label: "Reseller Digital Signage", href: `/partners/reseller-digital-signage-software` },
    ],
  },
  {
    title: "Trust & Compliance",
    type: "list",
    links: [
      { label: "Privacy Policy", href: `/privacy` },
      { label: "Terms of Service", href: `/terms` },
      { label: "Refund Policy", href: `/refund` },
      { label: "Data Processing Addendum", href: `/data-processing-addendum` },
      { label: "Sub-processors", href: `/sub-processors` },
      { label: "Security", href: `/digital-signage-security` },
      { label: "Cookie Policy", href: `/cookies` },
    ],
  },
];

export const footerSocials: FooterLink[] = [
  { label: "Facebook", href: "https://www.facebook.com/PickcelDigitalSignage", external: true, rel: "noopener noreferrer" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/pickcel/", external: true, rel: "noopener noreferrer" },
  { label: "Twitter", href: "https://x.com/PickcelSignage", external: true, rel: "noopener noreferrer" },
  { label: "YouTube", href: "https://www.youtube.com/channel/UCymlUh_ErgjloeyCnzH711g?sub_confirmation=1", external: true, rel: "noopener noreferrer" },
  { label: "Instagram", href: "https://www.instagram.com/pickceldigitalsignage/", external: true, rel: "noopener noreferrer" },
  { label: "Pinterest", href: "https://in.pinterest.com/pickceldigitalsignage/_created", external: true, rel: "noopener noreferrer" },
];

export type FooterOffice = {
  country: string;
  addressHtml: string;
  phoneHref: string;
  phoneText: string;
  emailHref: string;
  emailText: string;
  flag: "us" | "in";
};

export const footerOffices: FooterOffice[] = [
  {
    country: "USA",
    addressHtml:
      "SoHo - Hudson Square<br />101 Avenue of the Americas<br />8th and 9th Floors<br />New York 10013",
    phoneHref: "tel:19177958876",
    phoneText: "+1 917 795 8876",
    emailHref: "mailto:contact@pickcel.com",
    emailText: "contact@pickcel.com",
    flag: "us",
  },
  {
    country: "India",
    addressHtml:
      "#918, 3rd Floor, 5th Main Road<br />Sector 7, HSR Layout,<br />Bangalore, Karnataka, India 560102",
    phoneHref: "tel:+919740997922",
    phoneText: "+91 974 099 7922",
    emailHref: "mailto:contact@pickcel.com",
    emailText: "contact@pickcel.com",
    flag: "in",
  },
];
